(function () {
  "use strict";

  function startAutoplay() {
    var nodes = document.querySelectorAll('slide-show[data-deferred-autoplay="true"]');
    if (!nodes.length) return;

    nodes.forEach(function (el) {
      if (el.dataset.autoplayStarted === "1") return;

      var tries = 0;
      var maxTries = 60; // ~6s of polling at 100ms

      function tryStart() {
        var instance = el.slideInstance;
        if (instance && instance.Components && instance.Components.Autoplay) {
          try {
            instance.Components.Autoplay.play();
            el.dataset.autoplayStarted = "1";
            return;
          } catch (e) { /* retry */ }
        }
        if (++tries < maxTries) setTimeout(tryStart, 100);
      }

      tryStart();
    });
  }

  function schedule() {
    // Wait until slide-show is defined (deferred to window.load), then idle,
    // then a short grace period for Splide.mount() to settle.
    var go = function () {
      var delay = 800;
      var fire = function () { setTimeout(startAutoplay, delay); };
      if (window.requestIdleCallback) {
        window.requestIdleCallback(fire, { timeout: 3000 });
      } else {
        fire();
      }
    };

    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined("slide-show").then(go);
    } else {
      go();
    }
  }

  if (document.readyState === "complete") {
    schedule();
  } else {
    window.addEventListener("load", schedule, { once: true });
  }
})();
